import { render, staticRenderFns } from "./ChapterConfigurator.vue?vue&type=template&id=e846e258&scoped=true&"
import script from "./ChapterConfigurator.vue?vue&type=script&lang=js&"
export * from "./ChapterConfigurator.vue?vue&type=script&lang=js&"
import style0 from "./ChapterConfigurator.vue?vue&type=style&index=0&id=e846e258&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e846e258",
  null
  
)

export default component.exports